<template>
  <div class="invoice-list">
    <el-page-header content="发票列表" class="page-header" />
    <el-card>
      <el-button type="primary" icon="el-icon-plus" @click="$router.push('/create')">新建发票</el-button>
      <el-table :data="list" row-key="id" style="margin-top:16px" v-loading="loading">
        <el-table-column prop="invoice_number" label="订单编号" width="120" />
        <el-table-column prop="company_name" label="公司" />
        <el-table-column prop="grand_total" label="总计" width="100">
          <template slot-scope="scope">${{ (parseFloat(scope.row.grand_total) || 0).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'warning'" size="small">
              {{ scope.row.status === 1 ? '已完成' : '草稿' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="$router.push(`/create/${scope.row.id}`)">编辑</el-button>
            <el-button type="text" size="small" @click="exportPdf(scope.row.id)">导出PDF</el-button>
            <el-button type="text" size="small" style="color:#f56c6c" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import invoiceApi from '@/api/invoice'

export default {
  name: 'InvoiceList',
  data() {
    return { list: [], loading: false }
  },
  mounted() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const res = await invoiceApi.list()
        const data = res.data
        const arr = Array.isArray(data) ? data : []
        this.$set(this, 'list', arr)
      } catch (e) {
        this.$message.error('加载失败: ' + (e.message || ''))
      } finally {
        this.loading = false
      }
    },
    async exportPdf(id) {
      try {
        const res = await invoiceApi.exportPdf(id)
        const blob = new Blob([res.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `invoice-${id}.pdf`
        a.click()
        window.URL.revokeObjectURL(url)
        this.$message.success('导出成功')
      } catch (e) {
        this.$message.error('导出失败')
      }
    },
    handleDelete(row) {
      this.$confirm('确定删除该发票？', '提示', {
        type: 'warning'
      }).then(async () => {
        await invoiceApi.delete(row.id)
        this.$message.success('已删除')
        this.load()
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.invoice-list { padding: 24px; }
.page-header { margin-bottom: 20px; }
</style>
